<template>
  <img
    class="absolute inset-0 hidden h-screen w-full object-cover md:flex"
    src="../assets/photos/home/milan-csizmadia-photography-sportscar-automotive-lamborghini-huracan-green-trackday-hungaroring-motorsport-racing-livefast-lifestyle-sports-budapest-hungary-europe-worldwide-milancsizmadia.jpg"
    alt="" />
  <img
    class="absolute inset-0 flex h-screen w-full object-cover md:hidden"
    src="../assets/photos/phone/milan-csizmadia-photography-videography-automotive-lamborghini-huracan-green-trackday-hungaroring-motorsport-racing-livefast-lifestyle-sports-budapest-hungary-europe-worldwide-milancsizmadia.jpg"
    alt="" />
</template>

<script>
export default {
  name: 'Home'
}
</script>
